export default [
  {
    path: '/bolsa-familia',
    component: () => import('@/pages/BolsaFamilia/Index.vue'),
  },
  {
    path: '/bolsa-familia/criancas-mulheres',
    component: () => import('@/pages/BolsaFamilia/CriancasMulheres/Index.vue'),
  },
  {
    path: '/bolsa-familia/gestantes',
    component: () => import('@/pages/BolsaFamilia/Gestantes/Index.vue'),
  },
  {
    path: '/bolsa-familia/importar-acompanhamento',
    component: () =>
      import('@/pages/BolsaFamilia/ImportarAcompanhamento/Index.vue'),
  },
]
